module.exports = __webpack_public_path__ + "images/assets/4ba1b8c37163a7462be8d3a9b1cb9cbd.svg";